// src/api/apiClient.js

const API_BASE = 'https://api.hedger.bar/api';

// --- РЈРџР РђР’Р›Р•РќРР• РўРћРљР•РќРћРњ ---
const saveToken = (token) => {
  if (token) {
    localStorage.setItem('authToken', token);
  }
};

export const getToken = () => {
  return localStorage.getItem('authToken');
};

const removeToken = () => {
  localStorage.removeItem('authToken');
};

// РЈР»СѓС‡С€РµРЅРЅС‹Р№ РєР»Р°СЃСЃ РѕС€РёР±РєРё
export class ApiError extends Error {
  constructor(status, data) {
    super(data.message || 'An API error occurred');
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

// РЈРЅРёРІРµСЂСЃР°Р»СЊРЅР°СЏ С„СѓРЅРєС†РёСЏ РґР»СЏ Р·Р°РїСЂРѕСЃРѕРІ
const request = async (endpoint, options = {}) => {
  const url = `${API_BASE}${endpoint}`;
  const token = getToken();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers,
  };

  const res = await fetch(url, config);

  let data;
  try {
    data = await res.json();
  } catch (error) {
    data = { message: `Request failed with status ${res.status}` };
  }

  if (!res.ok) {
    if (res.status === 401) {
      removeToken();
    }
    throw new ApiError(res.status, data);
  }

  return data;
};

// ===================================================
// === Р­РљРЎРџРћР РўРР РЈР•РњР«Р• API-Р¤РЈРќРљР¦РР ===
// ===================================================

// === РђРќРђР›РР— РџРђР  (РћР¶РёРґР°РЅРёРµ РґРѕ 3 РјРёРЅСѓС‚) ===
export const analyzePairs = (params) => {
  const controller = new AbortController();
  // РЈСЃС‚Р°РЅР°РІР»РёРІР°РµРј С‚Р°Р№РјР°СѓС‚ 180 000 РјСЃ (3 РјРёРЅСѓС‚С‹)
  const timeoutId = setTimeout(() => controller.abort(), 180000);

  return request('/pairs/analyze', { 
    method: 'POST', 
    body: JSON.stringify(params),
    signal: controller.signal // РџСЂРѕРєРёРґС‹РІР°РµРј СЃРёРіРЅР°Р» РґР»СЏ РѕС‚РјРµРЅС‹ Р·Р°РїСЂРѕСЃР° РїРѕ С‚Р°Р№РјР°СѓС‚Сѓ
  }).finally(() => clearTimeout(timeoutId));
};

export const savePairTemplate = ({ templateName, analyzeRequest, ...rootFields }) =>
  request('/pairs/templates', {
    method: 'POST',
    body: JSON.stringify(
      analyzeRequest
        ? { templateName, analyzeRequest, ...rootFields }
        : { templateName, ...rootFields }
    )
  });

export const getPairTemplates = () => request('/pairs/templates');

export const getPairTemplateById = (publicTemplateId) => {
  if (!publicTemplateId) return Promise.reject(new Error('publicTemplateId is required.'));
  return request(`/pairs/templates/${publicTemplateId}`);
};

export const deletePairTemplate = (publicTemplateId) => {
  if (!publicTemplateId) return Promise.reject(new Error('publicTemplateId is required.'));
  return request(`/pairs/templates/${publicTemplateId}`, { method: 'DELETE' });
};

// === Р Р•Р“РРЎРўР РђР¦РРЇ Р РђРЈРўР•РќРўРР¤РРљРђР¦РРЇ ===
export const initializeRegistration = (email, password, referralCode) => {
  const payload = { email, password };
  if (referralCode) {
    payload.referralCode = referralCode;
  }
  return request('/register/initialize', { method: 'POST', body: JSON.stringify(payload) });
};
export const finalizeRegistration = (token, referralCode) => {
  const payload = { token };
  if (referralCode) {
    payload.referralCode = referralCode;
  }
  return request('/register/finalize', { method: 'POST', body: JSON.stringify(payload) });
};
export const login = async (email, password) => {
  const responseData = await request('/login', { method: 'POST', body: JSON.stringify({ email, password }) });
  if (responseData.token) {
    saveToken(responseData.token);
  }
  return responseData;
};
export const logout = () => {
  removeToken();
};

// === РџРћР›Р¬Р—РћР’РђРўР•Р›Р Р РђРљРљРђРЈРќРўР« ===
export const getUserProfile = () => request('/user');

export const changePassword = (currentPassword, newPassword) => 
  request('/user/change-password', { 
    method: 'POST', 
    body: JSON.stringify({ currentPassword, newPassword }) 
  });

export const verifyEmail = (token) => request('/verify-email', { method: 'POST', body: JSON.stringify({ token }) });
export const requestPasswordReset = (email) => request('/request-password-reset', { method: 'POST', body: JSON.stringify({ email }) });
export const resetPassword = (token, newPassword) => request('/reset-password', { method: 'POST', body: JSON.stringify({ token, newPassword }) });

// === Р СџР С’Р В Р СћР СњР вЂўР В Р С™Р С’ ===
export const getPartnerDashboard = (limit = 50, offset = 0) =>
  request(`/partner/dashboard?limit=${limit}&offset=${offset}`);

export const getPartnerInviteLinks = () => request('/partner/invite-links');

export const createPartnerInviteLink = (code) =>
  request('/partner/invite-links', { method: 'POST', body: JSON.stringify({ code }) });

export const getPartnerTransactions = ({ limit = 100, offset = 0, inviteCode, referredUserId } = {}) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (inviteCode) params.set('inviteCode', inviteCode);
  if (referredUserId) params.set('referredUserId', referredUserId);
  return request(`/partner/transactions?${params.toString()}`);
};

export const getPartnerWithdrawals = (limit = 100, offset = 0) =>
  request(`/partner/withdrawals?limit=${limit}&offset=${offset}`);

export const createPartnerWithdrawal = ({ amountUsdt, network, address, comment }) =>
  request('/partner/withdrawals', {
    method: 'POST',
    body: JSON.stringify({ amountUsdt, network, address, comment })
  });


// === Р‘РР Р–Р•Р’Р«Р• РђРљРљРђРЈРќРўР« ===
export const addExchangeAccount = (accountData) => request('/exchange-accounts', { method: 'POST', body: JSON.stringify(accountData) });
export const getExchangeAccounts = () => request('/exchange-accounts');
export const updateExchangeAccount = (publicAccountId, updateData) => request(`/exchange-accounts/${publicAccountId}`, { method: 'PATCH', body: JSON.stringify(updateData) });
export const deleteExchangeAccount = (publicAccountId) => request(`/exchange-accounts/${publicAccountId}`, { method: 'DELETE' });


// === РЎРўР РђРўР•Р“РР Р РђР’РўРћРўР Р•Р™Р”РРќР“ ===
export const saveStrategy = (strategyData) => request('/strategies', { method: 'POST', body: JSON.stringify(strategyData) });
export const getStrategies = (login) => request(`/strategies?login=${encodeURIComponent(login)}`);
export const deleteStrategy = (publicStrategyId) => {
  if (!publicStrategyId) return Promise.reject(new Error("publicStrategyId is required."));
  return request(`/strategies/${publicStrategyId}`, { method: 'DELETE' });
}
export const getStrategyById = (strategyId, login) => {
  let url = `/strategies/${strategyId}`;
  if (login) url += `?login=${encodeURIComponent(login)}`;
  return request(url);
};

// === РђР”РњРРќ-РџРђРќР•Р›Р¬ ===
export const getDashboardData = () => request('/dashboard');
export const checkAdminAccess = () => request('/admin/me');
const FAQ_STORAGE_MARKER = '__FAQ_DOCS__';
const FAQ_CHUNK_SIZE = 12000;

const getRecommendedStrategiesRaw = () => request('/recommended-strategies/all');

const getRecommendedId = (item) => item?.publicStrategyId || item?.strategyId || item?._id || null;

const isFaqStorageRecord = (item) =>
  String(item?.customStrategyName || '').startsWith(`${FAQ_STORAGE_MARKER}::`);

const parseFaqStorageMeta = (item) => {
  const raw = String(item?.customStrategyName || '');
  const parts = raw.split('::');
  if (parts.length !== 4 || parts[0] !== FAQ_STORAGE_MARKER) return null;

  const version = parts[1];
  const chunkIndex = Number(parts[2]);
  const totalChunks = Number(parts[3]);

  if (!version || !Number.isInteger(chunkIndex) || !Number.isInteger(totalChunks)) return null;
  if (chunkIndex < 1 || totalChunks < 1 || chunkIndex > totalChunks) return null;

  return { version, chunkIndex, totalChunks };
};

const chunkString = (value, size) => {
  if (!value) return [''];
  const chunks = [];
  for (let i = 0; i < value.length; i += size) {
    chunks.push(value.slice(i, i + size));
  }
  return chunks;
};

const buildFaqChunkPayload = (chunkName, chunkContent) => ({
  strategyName: 'pairs_trading',
  customStrategyName: chunkName,
  typeRecommendation: 'Admin',
  parameters: {
    symbol_a: 'BTCUSDT',
    symbol_b: 'ETHUSDT',
    timeframe: '15',
    zscore_period: 1,
    bar: 1,
    margin: 0,
    leverage: 1,
    risk_level: 'low',
    total_usdt_one_entry: 0,
    strategy_name: 'pairs_trading',
    strategy_method: 'zscore',
    commission_rate: 0,
    exit: 0,
    level_entry_positive: [1],
    level_entry_negative: [-1],
    description: chunkContent
  }
});

export const getRecommendedStrategies = async () => {
  const list = await getRecommendedStrategiesRaw();
  if (!Array.isArray(list)) return [];
  return list.filter((item) => !isFaqStorageRecord(item));
};

export const createRecommendedStrategy = (strategyData) => 
  request('/admin/recommended-strategies', { 
    method: 'POST', 
    body: JSON.stringify(strategyData) 
  });

export const updateRecommendedStrategy = (publicStrategyId, updateData) => 
  request(`/admin/recommended-strategies/${publicStrategyId}`, { 
    method: 'PATCH', 
    body: JSON.stringify(updateData) 
  });

export const deleteRecommendedStrategy = (publicStrategyId) => 
  request(`/admin/recommended-strategies/${publicStrategyId}`, { 
    method: 'DELETE' 
  });

export const getSharedFaqContent = async () => {
  const list = await getRecommendedStrategiesRaw();
  if (!Array.isArray(list)) return null;

  const records = list
    .filter(isFaqStorageRecord)
    .map((item) => {
      const meta = parseFaqStorageMeta(item);
      if (!meta) return null;

      return {
        meta,
        chunk: String(item?.parameters?.description || '')
      };
    })
    .filter(Boolean);

  if (!records.length) return null;

  const grouped = records.reduce((acc, record) => {
    const key = record.meta.version;
    if (!acc[key]) acc[key] = [];
    acc[key].push(record);
    return acc;
  }, {});

  const versions = Object.keys(grouped).sort((a, b) => Number(b) - Number(a));

  for (const version of versions) {
    const group = grouped[version];
    const totalChunks = group[0]?.meta?.totalChunks || 0;
    const uniqueChunks = new Map(group.map((record) => [record.meta.chunkIndex, record]));
    if (uniqueChunks.size !== totalChunks) continue;

    const ordered = [...uniqueChunks.values()].sort((a, b) => a.meta.chunkIndex - b.meta.chunkIndex);
    const payload = ordered.map((record) => record.chunk).join('');

    try {
      return JSON.parse(payload);
    } catch {
      // Ignore broken versions and continue.
    }
  }

  return null;
};

export const saveSharedFaqContent = async (content) => {
  const serialized = JSON.stringify(content || {});
  const chunks = chunkString(serialized, FAQ_CHUNK_SIZE);
  const version = String(Date.now());

  const current = await getRecommendedStrategiesRaw();
  const oldFaqRecords = Array.isArray(current) ? current.filter(isFaqStorageRecord) : [];

  for (let index = 0; index < chunks.length; index += 1) {
    const chunkName = `${FAQ_STORAGE_MARKER}::${version}::${index + 1}::${chunks.length}`;
    const payload = buildFaqChunkPayload(chunkName, chunks[index]);
    await createRecommendedStrategy(payload);
  }

  await Promise.all(
    oldFaqRecords.map((record) => {
      const id = getRecommendedId(record);
      if (!id) return Promise.resolve();
      return deleteRecommendedStrategy(id).catch(() => null);
    })
  );

  return true;
};

export const importMarkdownFromGitBook = async (sourceUrl) => {
  const input = String(sourceUrl || '').trim();
  if (!input) throw new Error('URL is required.');

  const normalized = /^https?:\/\//i.test(input) ? input : `https://${input}`;
  const proxyUrl = `https://r.jina.ai/http://${normalized.replace(/^https?:\/\//i, '')}`;

  const response = await fetch(proxyUrl);
  if (!response.ok) {
    throw new Error(`Import failed (${response.status})`);
  }

  return response.text();
};
// РЎС‚Р°СЂС‹Рµ РјРµС‚РѕРґС‹
export const createAutotradingConfig = (configData) => request('/autotrading', { method: 'POST', body: JSON.stringify(configData) });
export const getAutotradingConfigs = (login) => request(`/autotrading?login=${encodeURIComponent(login)}`);
export const updateAutotradingStatus = (autotradingId, isEnabled) => request(`/autotrading/${autotradingId}/autotrading-status`, { method: 'PATCH', body: JSON.stringify({ isAutotradingEnabled: isEnabled }) });
export const deleteAutotradingConfig = (autotradingId) => request(`/autotrading/${autotradingId}`, { method: 'DELETE' });
